export const oauthTokenEndpoint = '/oauth/token'
export const authorizeEndpoint = '/authorize'
export const setClientKeyEndpoint = '/client-key'

export const headersContentTypeFormUrlEncoded = {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
